import { Dispatch } from 'redux'
import { connect } from 'react-redux'

import ProductItemControls, { IStateProps, IDispatchProps, IOwnProps } from './ProductItemControls'
import { DashboardAction, requestPrint, requestProductAccept, resetFailedOrderId, setProductLoading } from '../../services/store/actions/dashboard/DashboardAction'

import  { IStoreState } from '../../services/store/IStoreState'
import FailedOrderReason from '../../constants/FailedOrderReason'

function mapStateToProps(state: IStoreState, ownProps: IOwnProps): IStateProps {
  const acceptKey = `accept-${ownProps.product.id}`
  const printKey = `print-${ownProps.product.id}`

  // Check if ANY product is loading globally
  const anyProductLoading = Object.values(state.Dashboard.productLoadingStates).some(loading => loading)

  return {
    notPreparedOrderId: state.Dashboard.failedOrder?.reason === FailedOrderReason.NOT_ALL_PRODUCTS_PREPARED
      ? state.Dashboard.failedOrder.orderId : undefined,
    acceptLoading: state.Dashboard.productLoadingStates[acceptKey] || false,
    printLoading: state.Dashboard.productLoadingStates[printKey] || false,
    anyProductLoading: anyProductLoading,
  }
}

function mapDispatchToProps(dispatch: Dispatch<DashboardAction>): IDispatchProps {
  return {
    requestProductAccept: (product, onEnd) => dispatch(requestProductAccept({product, onEnd})),
    requestPrint: (product, onEnd) => dispatch(requestPrint({product, onEnd})),
    resetFailedOrderId: () => dispatch(resetFailedOrderId()),
    setProductLoading: (productKey, isLoading) => dispatch(setProductLoading({productKey, isLoading})),
  }
}

export default connect<IStateProps, IDispatchProps, IOwnProps, IStoreState>(
  mapStateToProps,
  mapDispatchToProps
)(ProductItemControls)
